module.exports = __webpack_public_path__ + "static/media/zoomout.6d82f2ff.svg";